import { createContext, useContext } from "react";
import { ActivityColorCollection } from "./activity-color-collection";
import { ActivityColors } from "./activity-colors";
import { ActivityFeedGroup } from "./activity-feed-group";
import { ActivityFeedGroupItem } from "./activity-feed-group-item";
import { ActivityFollowButton } from "./activity-follow-button";
import { ActivityGroupItemStatus } from "./activity-group-item-status";

const ACTIVITY_INDICATORS = {
  1: ActivityColors,
  2: ActivityColorCollection,
  3: ActivityFollowButton,
  4: ActivityColorCollection,
};

const ActivityFeedContext = createContext();
export const useActivityFeed = () => useContext(ActivityFeedContext);
function ActivityFeedProvider({ data, children }) {
  return (
    <ActivityFeedContext.Provider value={data}>
      {children}
    </ActivityFeedContext.Provider>
  );
}

export const ActivityFeed = ({ apiData, contextData }) => {
  return (
    <ActivityFeedProvider data={contextData}>
      {apiData.activityFeedsList.map((activityGroup, index) => (
        <ActivityFeedGroup
          groupTitle={activityGroup.title}
          key={index}
        >
          {activityGroup.activityFeeds.map((activity, groupIndex) => {
            const RightSlotComponent =
              ACTIVITY_INDICATORS[activity.activityType];

            return (
              <ActivityFeedGroupItem
                leftSlot={<ActivityGroupItemStatus activityData={activity} />}
                rightSlot={<RightSlotComponent activityData={activity} />}
                key={groupIndex}
              />
            );
          })}
        </ActivityFeedGroup>
      ))}
    </ActivityFeedProvider>
  );
};
